<template>
  <div>
    <Modal>
      <template slot="header">
        <div class="flex items-center justify-between w-full">
          <h1 class="text-2xl font-bold text-white ">
            Change your {{ isTrialOrCanceled ? " trial " : "" }} plan here
          </h1>
          <button @click="close(false)">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.375 4.4375L13.8125 11L20.375 17.625C21.1875 18.375 21.1875 19.6875 20.375 20.4375C19.625 21.25 18.3125 21.25 17.5625 20.4375L11 13.875L4.375 20.4375C3.625 21.25 2.3125 21.25 1.5625 20.4375C0.75 19.6875 0.75 18.375 1.5625 17.625L8.125 11L1.5625 4.4375C0.75 3.6875 0.75 2.375 1.5625 1.625C2.3125 0.8125 3.625 0.8125 4.375 1.625L11 8.1875L17.5625 1.625C18.3125 0.8125 19.625 0.8125 20.375 1.625C21.1875 2.375 21.1875 3.6875 20.375 4.4375Z"
                fill="#6F6BBD"
              />
            </svg>
          </button>
        </div>
      </template>

      <template slot="body">
        <div class="flex flex-col w-full gap-10 my-10">
          <span
            class="inline w-auto mr-auto cursor-default"
            style="min-width: 200px;"
          >
            <span
              class="flex items-center justify-start gap-4 px-3 py-2 rounded-ah ring-1 ring-purple-stroke"
            >
              <img
                v-if="artist.avatar_url"
                :src="artist.avatar_url"
                width="50"
                height="50"
                class="rounded-full"
                alt="user image"
              />
              <span class="font-semibold text-white">{{ artist.name }}</span>
            </span>
          </span>

          <div class="">
            <p class="mb-2 font-semibold text-left text-light-purple-text">
              Select plan
            </p>

            <ul class="grid grid-cols-3 gap-4 pt-10 pb-6">
              <li
                v-for="(plan, i) in availablePlans"
                :key="'plan-' + i"
                class="relative flex flex-col "
              >
                <div
                  v-if="isActivePlan(plan.name)"
                  class="absolute top-0 w-full h-full p-3 pb-4 transform -translate-y-10 cursor-pointer ring-1 ring-regular-purple bg-regular-purple rounded-ah "
                >
                  <span class="font-semibold">Current Plan</span>
                </div>
                <div
                  class="z-10 flex-1 plan-selector font-montserrat ring-1"
                  :class="
                    plan.name == newPlan ? '  ring-dark-purple' : 'ring-white'
                  "
                  @click="selectPlan(plan.name)"
                >
                  <span
                    class="pb-2 font-semibold capitalize title font-montserrat"
                    >{{ plan.name }}</span
                  >
                  <span class="subtitle font-montserrat">
                    ${{
                      billing_interval == "monthly" || !yearly
                        ? plan.priceMonthly
                        : plan.priceYearly
                    }}
                    per
                    {{
                      billing_interval == "monthly" || !yearly
                        ? "Month"
                        : "Year"
                    }}
                  </span>
                  <span
                    style="height: 1px;"
                    class="w-full my-5 bg-purple-stroke"
                  ></span>
                  <ul class="flex flex-col w-full gap-4 ">
                    <li
                      class="flex items-center px-6 justify-start  gap-1.5 text-sm font-semibold text-lilac"
                      v-for="(feature, j) in plan.features"
                      :key="j"
                    >
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.7099 7.69814C18.617 7.60441 18.5064 7.53002 18.3845 7.47925C18.2627 7.42848 18.132 7.40234 17.9999 7.40234C17.8679 7.40234 17.7372 7.42848 17.6154 7.47925C17.4935 7.53002 17.3829 7.60441 17.29 7.69814L9.83995 15.1581L6.70995 12.0181C6.61343 11.9249 6.49949 11.8516 6.37463 11.8024C6.24978 11.7532 6.11645 11.7291 5.98227 11.7314C5.84809 11.7337 5.71568 11.7624 5.5926 11.8159C5.46953 11.8694 5.35819 11.9466 5.26495 12.0431C5.17171 12.1397 5.0984 12.2536 5.04919 12.3785C4.99999 12.5033 4.97586 12.6366 4.97818 12.7708C4.9805 12.905 5.00923 13.0374 5.06272 13.1605C5.11622 13.2836 5.19343 13.3949 5.28995 13.4881L9.12995 17.3281C9.22291 17.4219 9.33351 17.4963 9.45537 17.547C9.57723 17.5978 9.70794 17.6239 9.83995 17.6239C9.97196 17.6239 10.1027 17.5978 10.2245 17.547C10.3464 17.4963 10.457 17.4219 10.55 17.3281L18.7099 9.16814C18.8115 9.0745 18.8925 8.96085 18.9479 8.83435C19.0033 8.70785 19.0319 8.57124 19.0319 8.43314C19.0319 8.29504 19.0033 8.15844 18.9479 8.03194C18.8925 7.90544 18.8115 7.79178 18.7099 7.69814Z"
                          fill="#B1AFCD"
                        />
                      </svg>
                      <span
                        class="font-montserrat"
                        :class="i > 0 && j == 0 ? 'font-extrabold' : null"
                      >
                        {{ feature }}</span
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex items-center justify-end w-full">
            <button
              @click="updateArtistPlan"
              :disabled="disabled"
              class="button-default big"
            >
              <span class="px-10">
                {{ !loading ? "Change Plan" : "Loading..." }}
              </span>
            </button>
          </div>
        </div>
      </template>

      <template slot="footer">
        <div v-if="!isTrialOrCanceled" class="flex flex-col w-full gap-5 pt-5">
          <hr style="border-color:#6F6BBD" />
          <span
            class="inline w-full mx-auto cursor-default"
            style="max-width: 380px;"
          >
            <span
              class="flex items-center justify-between gap-10 px-6 py-4 rounded-ah ring-1 ring-purple-stroke"
            >
              <span class="font-semibold text-white">Want to cancel?</span>
              <button
                @click="cancelPlan"
                :disabled="loading"
                class="button-default button-default--outline-danger"
              >
                <span>
                  {{ !loading ? "Cancel Plan" : "Loading..." }}
                </span>
              </button>
            </span>
          </span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import {
  M_BRAINTREE_CHANGE_ARTIST_PLAN,
  M_TRIAL_CHANGE_ARTIST_PLAN_TO_ANY
} from "@/graphql";
import Swal from "sweetalert2";

export default {
  props: [
    "user",
    "artist",
    "subscription",
    "subscribing",
    "actionType",
    "yearly"
  ],
  components: {
    Modal
  },
  methods: {
    close(reload = false) {
      this.$emit("close", reload);
    },
    selectPlan(plan) {
      this.newPlan = plan;
    },
    isActivePlan(plan) {
      return this.artist.active_plan?.includes(plan);
    },
    async updateArtistPlan() {
      this.loading = true;
      try {
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: this.isTrialOrCanceled
            ? M_TRIAL_CHANGE_ARTIST_PLAN_TO_ANY
            : M_BRAINTREE_CHANGE_ARTIST_PLAN,
          variables: {
            artist_id: this.artist.id,
            selected_plan: this.newPlan
          }
        });

        const success = this.isTrialOrCanceled
          ? response.data.upgrade_artist_trial_plan_to_any.success
          : response.data.braintree_change_artist_plan.success;
        if (success)
          await this.$store.dispatch("snack", {
            text: "You've been changed to the " + this.newPlan + " plan!",
            autoDismiss: false
          });
        else
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Something went wrong updating your plan."
          });
      } catch (error) {
        console.log(error);
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Something went wrong updating your plan."
        });
      }
      this.loading = false;
      this.close(true);
    },
    async cancelPlan() {
      this.loading = true;
      const confirmUpdate = await Swal.fire({
        title: `Are you sure?`,
        html: `<p class="description">You are about to suspend <b style="color: #C5C5FF">${this.artist.name}</b>'s subscription.</p>`,
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "<span>Suspend</span>",
        cancelButtonText: "<span>Cancel</span>",
        confirmButtonClass: "button-danger big",
        cancelButtonClass: "button-secondary big",
        buttonsStyling: false,
        reverseButtons: true
      });

      if (!confirmUpdate.value) {
        this.loading = false;
        return;
      }

      try {
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_BRAINTREE_CHANGE_ARTIST_PLAN,
          variables: {
            artist_id: this.artist.id,
            selected_plan: ""
          }
        });

        const success = response.data.braintree_change_artist_plan.success;
        if (success)
          await this.$store.dispatch("snack", {
            text:
              "Your subscription for " +
              this.artist.name +
              " has been cancelled.",
            autoDismiss: false
          });
        else
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Something went wrong updating your plan."
          });
      } catch (error) {
        console.log(error);
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Something went wrong updating your plan."
        });
      }
      this.loading = false;
      this.close(true);
    }
  },
  data() {
    return {
      availablePlans: [
        {
          name: "bio",
          priceMonthly: 9,
          priceYearly: 90,
          features: [
            "Artist Bio Page",
            "Smart Deeplinks",
            "Pixel Integrations",
            "Custom Domains",
            "Advanced Analytics"
          ]
        },
        {
          name: "pro",
          priceMonthly: 19,
          priceYearly: 190,
          features: [
            "Everything in Lite",
            "Single Landing Pages",
            "Album Landing Pages",
            "Playlist Landing Pages"
          ]
        },
        {
          name: "max",
          priceMonthly: 29,
          priceYearly: 290,
          features: [
            "Everything in Pro",
            "1-Click Presave Pro",
            "Release Day Emails",
            "Auto-follow on Spotify"
          ]
        }
      ],
      planNames: {
        bio: "Bio",
        pro: "Pro",
        max: "Max"
      },
      newPlan: this.artist.active_plan,
      loading: false
    };
  },
  computed: {
    billing_interval() {
      return this.user.billing_interval;
    },
    disabled() {
      return this.loading || this.isActivePlan(this.newPlan);
    },
    isTrialOrCanceled() {
      return (
        (this.user.braintree_subscription_status == "Trial" ||
          this.user.braintree_subscription_status == "Canceled" ||
          !this.user.braintree_subscription_status) &&
        this.user.plan != "family"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-selector {
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
  background: $bg-type-1;
  align-items: center;
  border-radius: 10px;
  padding: 24px 0px;
  font-family: "Montserrat", "Open Sans", "Helvetica Neue Light",
    "Helvetica Neue", "Helvetica", "Arial";
  // padding: 20px 0px;
  flex: 1;

  &.selected {
    border: 1px solid #be3bff;
  }

  &:hover {
    cursor: pointer;
  }

  .title {
    /* 16/SemiBold */
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* White */
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .subtitle {
    /* 12/Regular */
    font-size: 14px;
    /* Text/type0 */
    color: $text-type-0;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
}
</style>
